import { createFileRoute, Navigate } from '@tanstack/react-router';
import { CreatorGuard } from '@/components/CreatorGuard/CreatorGuard';
import { DatasetsTable } from '@/components/DatasetsTable/DatasetsTable';
import PageNotFound from '@/components/Error/PageNotFound/PageNotFound';
import { FeatureFlagGuard } from '@/components/FeatureFlagGuard/FeatureFlagGuard';
import { FEATURE_FLAGS } from '@/config/features';
import { tw } from '@/lib/tailwind';

export const Route = createFileRoute('/dashboard/_primary-routes/datasets')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <FeatureFlagGuard
      flag={FEATURE_FLAGS.DATASETS_2_0}
      redirect={
        <Navigate
          to="/dashboard/data-source/$tab"
          params={{ tab: 'datasets' }}
          replace
        />
      }
    >
      <CreatorGuard fallback={<PageNotFound />}>
        <div className={tw('h-[calc(100vh-var(--dashboard-menu-height))] w-full overflow-auto bg-white p-6')}>
          <h3 className="mb-5 text-xl font-semibold">Datasets</h3>
          <DatasetsTable />
        </div>
      </CreatorGuard>
    </FeatureFlagGuard>
  );
}
